import React, { useState } from "react";
import { ExpandMore } from "@mui/icons-material";

import i18n from "i18n";

import Step from "components/MainApp/atoms/Wizard/Step";
import ItemTags from "components/MainApp/organisms/OrdersV4/Item-Tags";
import DeviceSelector from "components/Functionals/DeviceSelector";
import RoundedButton from "components/MainApp/atoms/RoundedButton";
import TagReadInput from "shared/components/Input/TagReadInput";

import tagIcon from "assets/images/tag-icon.svg";
import styles from "./PrepOrders.LoadPrepOrders.stepTags.module.scss";

export const StepTags = ({
  enabledRead,
  typeRead,
  refRead,
  associateRead,
  priorityRead,
  receiveEvent,
  originalItems,
  readTags,
  handleSearch,
  goBackFunc,
  handleDelete,
  handleDeleteAll,
  handleSend,
  isSimplified,
  selectedItems,
  searchedValue,
  title = i18n.t("scan.or.enter.product.tags"),
}) => {
  const [searchValue, setSearchValue] = useState("");

  const handleSearchValue = (e) => {
    setSearchValue(e.target.value.trim());
  };

  const handleSubmit = function(e) {
    e.preventDefault();
    e.stopPropagation();
    if (searchValue) {
      handleSearch(searchValue);
      setSearchValue("");
    }
  };

  // Group tags by SKU to display as ItemTags
  const groupedItems = readTags.reduce((acc, tag, idx) => {
    const sku = tag.sku || tag.item_sku || tag.product_sku || tag.tag || `unknown-${idx}`;
    const existing = acc.find(item => item.sku === sku);

    if (existing) {
      existing.tags.push(tag);
    } else {
      acc.push({
        sku: sku,
        title: tag.variables?.name || tag.name || tag.title || sku,
        item_files: tag.image ? [{ file_name: tag.image }] : [],
        tags: [tag],
        expectedUnits: tag.expectedUnits || 0
      });
    }
    return acc;
  }, []);

  const stepContent = (
    <div className={styles["reception-order-step-two-content"]}>
      <div
        className={styles["step-title-wrapper"]}
      >
        {goBackFunc && (
          <button
            className={styles["step-back-button"]}
            onClick={goBackFunc}
            type="button"
            aria-label="Go back"
          >
            <ExpandMore style={{ transform: "rotate(90deg)" }} />
          </button>
        )}
        <div className={styles["step-title"]}>{title}</div>
      </div>
      <div
        className={styles["reception-order-step-two-field"]}
        data-automation-id="input-search"
      >
        <DeviceSelector
          enabled={enabledRead}
          typeRead={typeRead}
          refRead={refRead}
          associateRead={associateRead}
          priorityRead={priorityRead}
          receiveEvent={receiveEvent}
          includeType={"MOB_READER"}
        />
        <div style={{ marginTop: "10px" }}>
          <TagReadInput 
            searchedValue={searchValue} 
            searchValue={handleSearchValue} 
            handleSubmit={handleSubmit} 
          />
        </div>

        <div className={styles["reception-order-step-two__tags-reads"]}>
          <article>
            <div>
              <picture>
                <img src={tagIcon} alt="tag icon" />
              </picture>
              <h4>{i18n.t("tags.read")}</h4>
            </div>
            <span>{readTags?.length || 0}</span>
          </article>
        </div>
        <div className={styles["load-movement-items-list"]}>
          {groupedItems &&
            groupedItems.map((item, index) => {
              return (
                <ItemTags
                  key={item.sku || item.tags?.[0]?.tag || index}
                  item={item}
                  quantity={item.tags.length}
                  expected={item.expectedUnits}
                  handleDelete={handleDelete}
                />
              );
            })}
        </div>

        <div className={styles["step-tags-footer"]}>
            <div
              className={`${styles["delete-all-button"]} ${styles["load-movement-items-button"]}`}
              onClick={handleDeleteAll}
            >
              {i18n.t("delete").toUpperCase()}
            </div>
          <div className={styles["continue-button-wrapper"]}>
            <RoundedButton
              legend={i18n.t("continue").toUpperCase()}
              type="button"
              state={readTags && readTags.length > 0 ? "enabled" : "disabled"}
              handleClick={handleSend}
            />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className={styles["reception-order-step-two-container"]}>
      <Step content={stepContent}></Step>
    </div>
  );
};

export default StepTags;